module.exports = __webpack_public_path__ + "img/logo-dark.211c805b.svg";